import React, { JSX } from 'react'
import { useEntitlements } from 'context/plan'
import { CHAT_FONT_OPTION_GROUPS, ChatFontOptionGroup, fontOptionGroupsFor } from 'lib/chatFonts'

export interface FontSelectProps {
  value: string
  onChange: (next: string) => void
  groups?: readonly ChatFontOptionGroup[]
  includeDefault?: boolean
  defaultLabel?: string
  className?: string
  id?: string
  disabled?: boolean
  'aria-label'?: string
  'data-testid'?: string
}

export const useFontPickerIsStaff = (): boolean => useEntitlements().staffUncapped

export const FontSelect = ({
  value,
  onChange,
  groups = CHAT_FONT_OPTION_GROUPS,
  includeDefault = true,
  defaultLabel,
  className,
  id,
  disabled,
  'aria-label': ariaLabel,
  'data-testid': testId
}: FontSelectProps): JSX.Element => {
  const isStaff = useFontPickerIsStaff()
  const list = fontOptionGroupsFor({ isStaff, currentKey: value, groups, includeDefault })
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      id={id}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {list.defaultOption != null && (
        <option value={list.defaultOption.key}>{defaultLabel ?? list.defaultOption.label}</option>
      )}
      {list.groups.map((group) => (
        <optgroup key={group.category} label={group.label}>
          {group.options.map((o) => (
            <option key={o.key} value={o.key}>{o.label}</option>
          ))}
        </optgroup>
      ))}
    </select>
  )
}
